// extracted by mini-css-extract-plugin
export var header = "header-module--header--8182f";
export var minimal = "header-module--minimal--cc63a";
export var scrolled = "header-module--scrolled--3f89d";